/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import {SVGIcon} from '@instructure/ui-svg-images'
import {type IconProps} from './iconTypes'

import {useScope as createI18nScope} from '@canvas/i18n'

const I18n = createI18nScope('block-editor')

export default ({elementRef, size = 'small'}: IconProps) => {
  return (
    <SVGIcon
      elementRef={elementRef}
      title={I18n.t('communication')}
      src={`<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.794922 7.9647V22.5109C0.794922 22.8544 1.00795 23.1599 1.32669 23.2738C1.64544 23.387 1.99996 23.2835 2.2106 23.016L5.78754 18.4703H20.6668C22.8607 18.4703 24.6412 16.6601 24.6412 14.4297V7.9647C24.6412 5.73427 22.8607 3.92407 20.6668 3.92407H4.76931C2.57545 3.92407 0.794922 5.73427 0.794922 7.9647ZM2.38468 7.9647C2.38468 6.62644 3.45299 5.54032 4.76931 5.54032H20.6668C21.9832 5.54032 23.0515 6.62644 23.0515 7.9647V14.4297C23.0515 15.768 21.9832 16.8541 20.6668 16.8541H5.40521C5.16357 16.8541 4.93544 16.9656 4.78441 17.1571L2.38468 20.207V7.9647ZM6.35906 8.77282C5.04274 8.77282 3.97443 9.85894 3.97443 11.1972C3.97443 12.5355 5.04274 13.6216 6.35906 13.6216C7.67538 13.6216 8.74369 12.5355 8.74369 11.1972C8.74369 9.85894 7.67538 8.77282 6.35906 8.77282ZM12.7181 8.77282C11.4018 8.77282 10.3334 9.85894 10.3334 11.1972C10.3334 12.5355 11.4018 13.6216 12.7181 13.6216C14.0344 13.6216 15.1027 12.5355 15.1027 11.1972C15.1027 9.85894 14.0344 8.77282 12.7181 8.77282ZM19.0771 8.77282C17.7608 8.77282 16.6925 9.85894 16.6925 11.1972C16.6925 12.5355 17.7608 13.6216 19.0771 13.6216C20.3934 13.6216 21.4617 12.5355 21.4617 11.1972C21.4617 9.85894 20.3934 8.77282 19.0771 8.77282ZM6.35906 10.3891C6.79783 10.3891 7.15394 10.7511 7.15394 11.1972C7.15394 11.6433 6.79783 12.0053 6.35906 12.0053C5.92029 12.0053 5.56418 11.6433 5.56418 11.1972C5.56418 10.7511 5.92029 10.3891 6.35906 10.3891ZM12.7181 10.3891C13.1568 10.3891 13.513 10.7511 13.513 11.1972C13.513 11.6433 13.1568 12.0053 12.7181 12.0053C12.2793 12.0053 11.9232 11.6433 11.9232 11.1972C11.9232 10.7511 12.2793 10.3891 12.7181 10.3891ZM19.0771 10.3891C19.5159 10.3891 19.872 10.7511 19.872 11.1972C19.872 11.6433 19.5159 12.0053 19.0771 12.0053C18.6383 12.0053 18.2822 11.6433 18.2822 11.1972C18.2822 10.7511 18.6383 10.3891 19.0771 10.3891Z" fill="currentColor"/>
</svg>
`}
      size={size}
    />
  )
}
